import React from 'react';
import { Form, Table } from 'semantic-ui-react';

const YasTable = ({ title = '', visible = true, options = { stackable: false, striped: false, attached: false, celled: false }, header = [], data = [], loading = false, emptyMessage = 'Aucune ligne trouvé', isEmpty = false, children }) => {
  const getValueOfRow = (obj, prop, defval) => {
    if (typeof defval == 'undefined') defval = null;
    prop = prop.split('.');
    for (const element of prop) {
      if (typeof obj[element] == 'undefined') return defval;
      obj = obj[element];
    }
    return obj;
  };

  return (
    visible && (
      <div className="rounded flex flex-col w-full max-w-full   shadow-sm border border-gray-200 mb-2 bg-white">
        {title && <div className="font-bold p-4 bg-blue-100 flex items-center ">{title}</div>}
        <div className="text-xs md:text-sm m-2 md:m-4 bg-white max-w-full ">
          <Form loading={loading}>
            <Table stackable={options.stackable} striped={options.striped} attached={options.attached} celled={options.celled} className="customTable unstackable">
              <Table.Header>
                <Table.Row>
                  {header &&
                    header.map((head, index) => (
                      <Table.HeaderCell key={`h-${head.selector}-${index}`} textAlign={head.textAlign}>
                        {head.label}
                      </Table.HeaderCell>
                    ))}
                </Table.Row>
              </Table.Header>
              {!isEmpty ? (
                <Table.Body>
                  {data.map((row, index) => (
                    <Table.Row key={`table_row_${index + 1}`} active={row.active} error={row.error} warning={row.warning}>
                      {header ? (
                        header.map((head, ind) => (
                          <Table.Cell key={`table_cell_${header.selector}_${ind + 1}`} textAlign={head.textAlign ? head.textAlign : 'left'} verticalAlign="middle" collapsing={head.collapsing} positive={head.positive} negative={head.negative}>
                            {head.component ? head.component(row, index) : getValueOfRow(row, head.selector)}
                          </Table.Cell>
                        ))
                      ) : (
                        <Table.Cell />
                      )}
                    </Table.Row>
                  ))}
                </Table.Body>
              ) : (
                <Table.Body>
                  <Table.Row>
                    <Table.Cell>{emptyMessage}</Table.Cell>
                  </Table.Row>
                </Table.Body>
              )}
            </Table>
            <br />
            {children}
          </Form>
        </div>
      </div>
    )
  );
};

export default YasTable;
